module.exports = __webpack_public_path__ + "img/Animales-INGE-V9-HD.50d14eeb.png";